/**
 * Application Version Configuration
 *
 * This file contains the semantic version number for the BHCS application.
 * Follow semantic versioning (MAJOR.MINOR.PATCH):
 * - MAJOR: Breaking changes that require user action
 * - MINOR: New features that are backward compatible
 * - PATCH: Bug fixes that are backward compatible
 *
 * Version format: v{MAJOR}.{MINOR}.{PATCH}
 * Example: v1.0.0, v1.1.0, v1.1.1, v2.0.0
 */

export const APP_VERSION = '3.98.2';

export const VERSION_INFO = {
  major: 3,
  minor: 98,
  patch: 2,
  full: `v${APP_VERSION}`,
  display: `v${APP_VERSION}`,
  // Release date for this version (YYYY-MM-DD)
  releasedOn: '2026-11-03',
} as const;

// Export for easy access
export default VERSION_INFO;
